import { Component } from '@theme/component';

class NeobrutalistHeroBanner extends Component {
  #current = 0;
  #interval = null;

  connectedCallback() {
    super.connectedCallback();
    this.#initSlider();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#stopAutoplay();
  }

  #initSlider() {
    const slides = this.querySelectorAll('.neobrutalist-hero__slide');
    if (slides.length <= 1) return;

    // Attach click events to nav buttons & dots via event delegation
    this.addEventListener('click', this.#handleClick.bind(this));

    this.#showSlide(0);
    this.#startAutoplay();
  }

  #handleClick(e) {
    const prevBtn = e.target.closest('.neobrutalist-hero__nav-btn--prev');
    if (prevBtn) {
      e.preventDefault();
      this.prevSlide();
      this.#resetAutoplay();
      return;
    }

    const nextBtn = e.target.closest('.neobrutalist-hero__nav-btn--next');
    if (nextBtn) {
      e.preventDefault();
      this.nextSlide();
      this.#resetAutoplay();
      return;
    }

    const dot = e.target.closest('.neobrutalist-hero__dot');
    if (dot) {
      e.preventDefault();
      const index = parseInt(dot.getAttribute('data-index'), 10);
      if (!isNaN(index)) {
        this.goToSlide(index);
        this.#resetAutoplay();
      }
    }
  }

  goToSlide(index) {
    const slides = this.querySelectorAll('.neobrutalist-hero__slide');
    if (slides.length === 0) return;
    this.#current = (index + slides.length) % slides.length;
    this.#showSlide(this.#current);
  }

  prevSlide() {
    this.goToSlide(this.#current - 1);
  }

  nextSlide() {
    this.goToSlide(this.#current + 1);
  }

  #showSlide(index) {
    const slides = this.querySelectorAll('.neobrutalist-hero__slide');
    const dots = this.querySelectorAll('.neobrutalist-hero__dot');

    slides.forEach((slide, i) => {
      if (i === index) {
        slide.classList.add('neobrutalist-hero__slide--active');
        slide.style.display = 'grid';
        slide.setAttribute('aria-hidden', 'false');
      } else {
        slide.classList.remove('neobrutalist-hero__slide--active');
        slide.style.display = 'none';
        slide.setAttribute('aria-hidden', 'true');
      }
    });

    dots.forEach((dot, i) => {
      if (i === index) {
        dot.classList.add('neobrutalist-hero__dot--active');
        dot.setAttribute('aria-selected', 'true');
      } else {
        dot.classList.remove('neobrutalist-hero__dot--active');
        dot.setAttribute('aria-selected', 'false');
      }
    });
  }

  #startAutoplay() {
    const autoplay = this.getAttribute('data-autoplay') === 'true';
    if (!autoplay) return;

    const speedSec = parseInt(this.getAttribute('data-autoplay-speed') || '5', 10);
    this.#interval = setInterval(() => {
      if (this.matches(':hover')) return; // pause autoplay on hover
      this.nextSlide();
    }, speedSec * 1000);
  }

  #stopAutoplay() {
    if (this.#interval) {
      clearInterval(this.#interval);
      this.#interval = null;
    }
  }

  #resetAutoplay() {
    this.#stopAutoplay();
    this.#startAutoplay();
  }
}

if (!customElements.get('neobrutalist-hero-banner')) {
  customElements.define('neobrutalist-hero-banner', NeobrutalistHeroBanner);
}
